import { RadioCardGroup } from '@components/radio-card';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { SSOPrefillMode } from 'api/journey-forms/requests';

export type SsoPrefillSectionProps = {
  currentMode: SSOPrefillMode;
  onChange: (mode: SSOPrefillMode) => void;
};

export const SsoPrefillSection = ({ currentMode, onChange }: SsoPrefillSectionProps) => {
  const { t } = useScopedTranslate(locale);

  return (
    <Stack space={4}>
      <Separator />
      <Stack space={2}>
        <Text text={t('ssoIdentityTitle')} font="bold18" />
        <Text text={t('ssoIdentityDescription')} font="regular14" color="textSecondary" />
      </Stack>
      <RadioCardGroup
        label={t('ssoIdentityRadioLabel')}
        hideLabel
        value={currentMode}
        onChange={(value) => onChange(value as SSOPrefillMode)}
        defaultBadgeValue="inherit"
        defaultBadgeLabel={t('ssoDefaultBadge')}
      >
        <RadioCardGroup.Option
          value="inherit"
          label={t('ssoOptionInherit')}
          helpText={t('ssoOptionInheritHelp')}
        />
        <RadioCardGroup.Option
          value="do_not_use"
          label={t('ssoOptionDoNotUse')}
          helpText={t('ssoOptionDoNotUseHelp')}
        />
        <RadioCardGroup.Option
          value="prefill_only"
          label={t('ssoOptionPrefillOnly')}
          helpText={t('ssoOptionPrefillOnlyHelp')}
        />
        <RadioCardGroup.Option
          value="prefill_and_lock"
          label={t('ssoOptionPrefillAndLock')}
          helpText={t('ssoOptionPrefillAndLockHelp')}
        />
      </RadioCardGroup>
    </Stack>
  );
};

const locale = {
  en: {
    ssoIdentityTitle: 'Portal identity for submitter fields',
    ssoIdentityDescription:
      "This form is shown on an SSO portal. Choose how the signed-in user's name and email are used",
    ssoIdentityRadioLabel: 'Portal identity mode',
    ssoOptionInherit: 'Inherit portal settings',
    ssoOptionInheritHelp: 'Use the portal default behavior',
    ssoOptionDoNotUse: 'Do not use portal identity',
    ssoOptionDoNotUseHelp: 'Users enters name and email manually',
    ssoOptionPrefillOnly: 'Pre-fill only',
    ssoOptionPrefillOnlyHelp: 'Name and email are pre-filled but the user can edit them',
    ssoOptionPrefillAndLock: 'Pre-fill and lock',
    ssoOptionPrefillAndLockHelp: 'Name and email are pre-filled and can not be edited',
    ssoDefaultBadge: 'Default',
  },
};
